import React from 'react'
import SectionBlock from './template/SectionBlock'
import SectionHeading from './template/SectionHeading'
import Heading from './template/Heading'
import { Link } from 'react-router-dom'
import { CircleArrowRight } from 'lucide-react'
import { FaGithub, FaLinkedin, FaMedium, FaTwitter } from 'react-icons/fa'

export default  function ConnectMe() {
    return (
        <SectionBlock cols='2' className='grid-cols-1 gap-10 py-12 pb-12 text-center lg:grid-cols-2 lg:gap-y-0 lg:gap-x-12 lg:pb-20 lg:text-left'>
            <SectionHeading number='03' content="Connect Me" className='hidden lg:flex col-span-2 justify-center lg:justify-start ' />
            <div className=' col-span-2 lg:col-span-1 lg:mr-20 self-start'>
            <SectionHeading number='03' content="Connect Me" className='flex lg:hidden col-span-2 justify-center lg:justify-start ' />
                <Heading className='mx-auto max-w-[16ch] sm:max-w-[14ch] md:max-w-[12ch] lg:mx-0'>Let&apos;s turn an idea, question, or brief into a clear next step.</Heading>
            </div>
            <div className='flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between  h-full col-span-2 lg:col-span-1'>
                <div className='text-primary flex flex-col justify-center items-center lg:items-start '>
                    <h3 className="pb-6 text-xl uppercase sm:text-2xl lg:pb-10">
                        get in touch
                    </h3>
                    <h4 className="break-all pb-8 text-lg normal-case sm:text-2xl lg:pb-10">
                        <Link to="mailto:tuhinkairii@gmail.com">tuhinkairii@gmail.com</Link>
                    </h4>
                    <span className='grid w-full grid-cols-2 gap-6 text-xs uppercase tracking-[0.2em] sm:flex sm:flex-wrap sm:justify-center sm:gap-8 sm:text-sm lg:justify-start lg:gap-10'>
                        <Link className='hover:text-secondary flex flex-col items-center gap-2' to="https://www.linkedin.com/in/tuhinkairi/"><FaLinkedin size={30}/> LinkedIn</Link>
                        <Link className='hover:text-secondary flex flex-col items-center gap-2' to="https://github.com/tuhinkairi"><FaGithub size={30}/> GitHub</Link>
                        <Link className='hover:text-secondary flex flex-col items-center gap-2' to=""><FaTwitter size={30}/> Twitter</Link>
                        <Link className='hover:text-secondary flex flex-col items-center gap-2' to="https://medium.com/@tuhinkairi"><FaMedium size={30}/> Medium</Link>
                    </span>
                </div>
                <div className='flex items-center justify-center lg:justify-end'>
                    <Link to="/connect/onboarding" className='cursor-pointer animate-bounce'>
                        <CircleArrowRight size={56} absoluteStrokeWidth={true} className='hover:text-secondary sm:w-16 sm:h-16 lg:w-[70px] lg:h-[70px]' />
                    </Link>
                </div>
            </div>
        </SectionBlock>
    )
}
